import _classCallCheck from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/xampp/htdocs/jpuser-dev/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/label/labelview
 */
import View from '../view';
import '../../theme/components/label/label.css';
/**
 * The label view class.
 *
 * @extends module:ui/view~View
 */

var LabelView = /*#__PURE__*/function (_View) {
  _inherits(LabelView, _View);

  var _super = _createSuper(LabelView);

  /**
   * @inheritDoc
   */
  function LabelView(locale) {
    var _this;

    _classCallCheck(this, LabelView);

    _this = _super.call(this, locale);
    /**
     * The text of the label.
     *
     * @observable
     * @member {String} #text
     */

    _this.set('text');
    /**
     * The `for` attribute of the label (i.e. to pair with an `<input>` element).
     *
     * @observable
     * @member {String} #for
     */


    _this.set('for');

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'label',
      attributes: {
        class: ['ck', 'ck-label'],
        for: bind.to('for')
      },
      children: [{
        text: bind.to('text')
      }]
    });

    return _this;
  }

  return LabelView;
}(View);

export { LabelView as default };